import { render, staticRenderFns } from "./EditRoomStatus.vue?vue&type=template&id=1b96c4fd&scoped=true&"
import script from "./EditRoomStatus.vue?vue&type=script&lang=ts&"
export * from "./EditRoomStatus.vue?vue&type=script&lang=ts&"
import style0 from "./EditRoomStatus.vue?vue&type=style&index=0&id=1b96c4fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b96c4fd",
  null
  
)

export default component.exports